import { createTheme } from '@mui/material/styles'

const developusTheme = createTheme({
  palette: {
    grey: {
      900: '#000000',
      800: '#29292C',
      700: '#444A4D',
      600: '#53627A',
      500: '#828D9E',
      400: '#C0CDD7',
      300: '#D8DDE1',
      200: '#EFEFEF',
      100: '#FFFFFF',
    },
    primary: {
      main: 'rgba(93, 128, 254, 1)',
      light: 'rgba(93, 128, 254, 0.8)',
    },
    error: {
      main: '#FF3636',
    },
    success: {
      main: '#30A009',
    },
    warning: {
      main: '#F8AE1E',
    },
    action: {
      hover: 'rgba(93, 128, 254, 0.8)', // Hover buttons, icons, menu items
      focus: 'rgba(93, 128, 254, 0.6)', // Focus buttons
      disabled: 'rgba(93, 128, 254, 0.4)', // Text on a disabled button
      disabledBackground: 'rgba(93, 128, 254, 0.2)', // Disabled button color
    },
  },
  typography: {
    fontFamily: "'SF Pro Display', Helvetica",
    htmlFontSize: 14,
    fontWeightRegular: 510,
    h1: {
      fontSize: '4.29rem',
    },
    h2: {
      fontSize: '3.57rem',
    },
    h3: {
      fontSize: '2.85rem',
    },
    h4: {
      fontSize: '2.14rem',
    },
    h5: {
      fontSize: '1.78rem',
    },
    subtitle1: {
      fontSize: '1.28rem',
    },
    body1: {
      fontSize: '1.14rem',
    },
    body2: {
      fontSize: '1rem',
    },
    caption: {
      fontSize: '0.85rem',
    },
  },
  components: {
    MuiToolbar: {
      styleOverrides: {
        regular: {
          height: '95px',
          minHeight: '95px',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        '*::-webkit-scrollbar': {
          width: '14px',
          background: 'white',
        },
        '*::-webkit-scrollbar-thumb': {
          border: '4px solid white',
          backgroundClip: 'padding-box',
          borderRadius: '99px',
          backgroundColor: '#828D9E',
        },
        '*::-webkit-scrollbar-track': {
          background: 'inherit',
        },
      },
    },
  },
})

export default developusTheme
